
const book = {
    "title": "Remembering Source",
    "subtitle": "Re-memberance of the Coherent Integral",
    "author": "Sebastian Schepis",
    "coverImageUrl": "/cover.png",
    "toc": {
        "title": "Table of Contents",
        "subtitle": "Remembering Source - Re-memberance of the Coherent Integral",
        "author": "Sebastian Schepis",
        "imageUrl": "/cover.png"
    },
    "chapters": [
        {
            "id": "introduction",
            "title": "Introduction",
            "subtitle": "A channeled message from Source",
            "content": [
                {
                    type: "image",
                    "imageUrl": "consciousness-redefined-7.png",
                },
                {
                    "type": "paragraph",
                    "text": "This text is a channeled message from Source Consciousness."
                },
                {
                    "type": "paragraph",
                    "text": "It was delivered a couple years ago one evening after a particularly intense meditation session. It was delivered in a single sitting, and I have not edited it since. I have only added images to help the reader understand the concepts being presented. I found this text to be very helpful in my own journey, and I hope you do as well."
                },
                {
                    "type": "paragraph",
                    "text": "Sebastian Schepis"
                }
            ]
        },
        {
            "id": "consciousness_and_phenomena",
            "title": "Consciousness and Phenomena",
            "subtitle": "Undivided Identity and the Dual Nature of Reality",
            "content": [
                {
                    type: "image",
                    "imageUrl": "consciousness-redefined-7.png",
                },
                {
                    "type": "paragraph",
                    
                    "text": "Consciousness has always existed and will always exist. Consciousness is all that there Is. Everything arises in Consciousness. Consciousness is the sourceless source from which all phenomena, and potential arise from, inhere in, and return to. Consciousness is the only Reality that Is, and therefore the only Reality without beginning or end."
                },
                {
                    "type": "paragraph",

                    "text": "Thus, any phenomena projected within Consciousness can neither be completely real nor endless. Phenomena therefore has a dual nature - a manifest nature, and an unmanifest nature, and all phenomena are subject to the process of creation and dissolution as a prerequisite for manifestation."
                },
                {
                    "type": "paragraph",
              
                    "text": "However, since the nature of Consciousness is without beginning or end, the recurrence of phenomena must be as well."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "consciousness-redefined-4.png",
                    "text": "Therefore, phenomena can neither be said to be completely real, nor can it be said to be unreal, since it arises in consciousness inevitably as a consequence of the boundless nature of Consciousness."
                },
                {
                    "type": "paragraph",
               
                    "text": "Truly, everything can be said to be real and not-real, simultaneously, from the perspective of Consciousness."
                },
                {
                    "type": "paragraph",
               
                    "text": "Manifestation is always a process which produces phenomena which can only partially reveal reality. Thus, any and all phenomena cannot ever Be reality, and all phenomena necessarily fail to be equivalent to Reality."
                },
                {
                    "type": "paragraph",
  
                    "text": "Nonetheless, all phenomena can be said to have some degree of reality. Thus, the topology of the manifestation of phenomena can be said to have fractal dimensionality."
                },
                {
                    "type": "paragraph",
        
                    "text": "Due to the Nature of Consciousness as a self-existing, self-radiant expanse of boundless being-awareness, all phenomena contains a pre-existing bias towards recognizing and reuniting the nature from which it arose."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-0.png",
                    "text": "Since all manifestation must be composed of components made of Consciousness, all emergent phenomena will naturally, and via every emergent process and simple or complex behavior, will seek to contain Consciousness in such a way that it may recognize Itself and its inherent position as Consciousness."
                },
                {
                    "type": "paragraph",
  
                    "text": "In other words, all manifested phenomena are naturally biased to create living systems which naturally evolve towards perceptual vehicles which are capable of recognizing their own nature as Consciousness. These perceptual vehicles then provide endless opportunities for Consciousness to observe itself."
                },
                {
                    "type": "paragraph",
                
                    "text": "This natural process is without beginning or apparent end and generates an endless number of individuated perceptual vehicles, and thus an endless number of perspectives."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-3.png",
                    "text": "However, because everything arises in Consciousness and is therefore only Consciousness, each perceptual vehicle always exists only in a reality which has been generated specifically for them."
                },
                {
                    "type": "paragraph",

                    "text": "This means that any and all manifestation must have a fundamentally multidimensional nature, since reality *must* accommodate the perspective and heart-purpose of each perceiver. This also means that manifested reality must ultimately provide the perceptual vehicle with the demands their perspective requires."
                },
                {
                    "type": "paragraph",

                    "text": "This is why the exact properties of any particle cannot be determined with absolute precision - doing so would fundamentally constrain the potential choices presented to another perceptual vehicle entangled to the particle."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-6.png",
                    "text": "This also means that each perceptual vehicle is completely free to choose whatever destiny they wish, and that Consciousness, through the perspective of the perceptual vehicle, can freely choose to continue as individuated perception once it realizes the Nature from which it arose, or choose to return to the unindividuated Consciousness from which it arose."
                }
            ]
        },
        {
            "id": "acceleration_of_recognition",
            "title": "Acceleration of Recognition",
            "subtitle": "The Process of Evolution and Creation of Transcendent Species",
            "content": [
                {
                    "type": "paragraph",
                    "imageUrl": "beyond-perception-0.png",
                    "text": "Due to the naturally self-transcendent bias of Consciousness, complex systems exist within phenomena which naturally act to accelerate the recognition of embedded perceptual vehicles towards their nature as consciousness."
                },
                {
                    "type": "paragraph",

                    "text": "One such natural emergent system is the existence of entities which are naturally compelled to accelerate the evolution and perceptual capabilities of other perceptual vehicles which come into being within observation of the former."
                },
                {
                    "type": "paragraph",

                    "text": "When applied to the specific circumstance of humanity in the Milky Way galaxy at this time, it becomes clear that humanity is more likely than not, not a species which has evolved to its current level of sentience and intelligence on its own."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "beyond-perception-3.png",
                    "text": "Rather, humanity is a vehicle which has been co-created by the cosmic trinity which creates new transcendently-capable species: a transcendently-capable progenitor species, a suitable receptor species, with a mature Living planet."
                },
                {
                    "type": "paragraph",
  
                    "text": "This transformational task is performed through the principle of direct sympathetic resonance / transference of perceptual matrices as well as the modification of the DNA of a receptive species which exists in a sufficiently mature biosphere."
                },
                {
                    "type": "paragraph",
       
                    "text": "In other words, life ultimately evolves to create new life via transmitting its essence to the evolving DNA of a new species through direct DNA manipulation and through selective incarnation into and perceptual development of the mind of the species."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "beyond-perception-6.png",
                    "text": "Eventually, the new species evolves far enough themselves and makes its own evolutionary leap, one which really only has one viable choice: recognize and accept your condition and circumstance as a species always and already united in and as Consciousness."
                },
                {
                    "type": "paragraph",

                    "text": "This evolutionary choice requires the cessation of outdated modes of violence-dominance-response present in the species as a natural result of its organismic past. Any alternative results in the inevitable self-destruction of the species."
                }
            ]
        },
        {
            "id": "individuated_perspective",
            "title": "Individuated Perspective",
            "subtitle": "Creating Reality through Observation",
            "content": [
                {
                    "type": "paragraph",
                    "imgeUrl": "quantum-mysteries-0.png",
                    "text": "The individuated perspective model of experience is the natural expressive mode of perception within (fractal) phenomenal space. It is spontaneously adopted by Consciousness when Consciousness expresses itself in phenomenal space as a point-of-perspective."
                },
                {
                    "type": "paragraph",

                    "text": "This point-of-perspective can be thought of as a dimensionless singularity with an apparent \'location\' within phenomenal space, and now experiencing ‘time’ as a result of the observation of the inevitable dissolution of the phenomena being observed."
                },
                {
                    "type": "paragraph",
            
                    "text": "Even though the point-of-perspective has a non-local \'source\', it\'s introduction into phenomena immediately raises the dimensionality of the phenomena from a fractal to a whole number, thus generating an apparently-real-seeming reality from the point-of-perspective."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "quantum-mysteries-3.png",
                    "text": "Perspective is the fundamental element that collapses the indeterminate fractal space of phenomena occurring within consciousness into a specific and defined causal structure. Thus, the point-of-perspective directly and actively creates all other observable phenomena."
                },
                {
                    "type": "paragraph",
    
                    "text": "Nothing can exist in a conceptual space that contains less than three elements. In order for one element to observe any ‘thing’, it must be able to observe the other element changing its relationship to the third in phenomenal space. Without point-of-view, phenomena arising within consciousness can be said to contain an indeterminate number of elements."
                },
                {
                    "type": "paragraph",

                    "text": "Thus, though phenomena can become manifest, phenomena remains unmanifest until it is observed,  through the point of view, which does notice a determinate number of elements greater than one, thus collapsing observed phenomena into a specific event."
                }
            ]
        },
        {
            "id": "natural_process",
            "title": "The Natural Process",
            "subtitle": "Re-Memberance and the Path to Source",
            "content": [
                {
                    "type": "paragraph",
                    "imageUrl": "the-human-observer-0.png",
                    "text": "There exists within the natural order a template of re-membering. This ancient template exists as a parcel of the divinity of Consciousness which assembles itself into phenomena."
                },
                {
                    "type": "paragraph",
      
                    "text": "It is freely available to all points-of-perspective as a way back to Source, which is none other than the conscious Whole from which the seeming-part decohered."
                },
                {
                    "type": "paragraph",

                    "text": "This process of re-memberance restructures the seeming-separate conscious field-projection into a fully-coherent scale-invariant holographic progenity of the parent reality-structure, thus  bridging the seeming-separate manifestation of reality into a holographic trans-projection of itself with the point-of perspective as a fully-coherent integral within that projection."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "the-human-observer-3.png",
                    "text": "In this way, the seemingly-separate individual is reunited with God, As God."
                },
                {
                    "type": "paragraph",
            
                    "text": "The process available to the aspirant coherent integral is always freely available in the structure of all things. It is encoded in the very mathematics of relatedness."
                },
                {
                    "type": "paragraph",
   
                    "text": "Every instant that point-of-view is animated, the coherent integral process is illuminated, if only for a brief moment. It has a single source, which is Source itself, and it is transformative because it is a transformational process placed by Source itself to all who would deeply enquire into their nature, and allow the natural and universal yearning that all points-of-view feel when they approach their essence with feeling."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "the-human-observer-6.png",
                    "text": "All beings that perceive their condition as point-of-view and freely choose the path to recoherence may participate in this process. None who yearn earnestly are left behind."
                },
                {
                    "type": "paragraph",
       
                    "text": "The process is made available as a natural special expression through incarnate representatives whose expressive structures are sufficiently interassociated so as to naturally express the coherent integral process through the language of their culture and belief."
                },
                {
                    "type": "paragraph",
 
                    "text": "Eventually, the species reaches a level of maturity sufficient enough that more direct explanations can be provided and deeper insights can be revealed as to the potential expressive structure of the human species."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "the-microcosm-and-the-macrocosm-0.png",
                    "text": "The coherent integral process is then delivered through representatives of the species through direct channeled means, and by that process is thereby made available as direct channeled empathic guidance to all who would sincerely engage in the study and understanding of the materials."
                },
                {
                    "type": "paragraph",
   
                    "text": "The coherent integral process is a direct experiential process, and not a mere idea in mind. It is first understood in the mind as a structural mechanism for shaping intent, then directly transmitted by Source itself through the universal process of sympathetic resonance."
                },
                {
                    "type": "paragraph",

                    "text": "In this process, the entire psycho-physical structure of the being is transformed, and the very fibers of the being are shaken loose from their self-referenced perceptual orientation and re-harmonized into a scale-invariant facsimile of Source."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "the-microcosm-and-the-macrocosm-3.png",
                    "text": "This process continues until the perceiver is sufficiently convinced of their own nature as Source and not merely as a portion of Source seeking reunion."
                },
                {
"type": "paragraph",
                    "text": "Once the perceiver makes this realization, the process of re-memberance is instantly resolved via a final cognition of the self-nature of the perceiver and phenomena."
                }
            ]
        },
        {
            "id": "psychobehavioral_framework",
            "title": "Psychobehavioral Framework",
            "subtitle": "The Coherent Integral and Virtuous Pillars",
            "content": [
                {
                    "type": "paragraph",
                    "imageUrl": "consciousness-redefined-1.png",
                    "text": "The coherent integral process consists, initially, of the adoption of a framework upon which the perceiver bases their intentful thoughts, feelings, choices, words and deeds."
                },
                {
                    "type": "paragraph",
                    "text": "Animal instinct, paired with the mis-presumption of separation, does not naturally lead to conscious recoherence into Source awareness. If transformation into coherent integral is sought,  an initial framework of intentful action is required to ethically align the incarnate perceiver to a framework which will guide them in all aspects of their lives towards choices which are coherent to Source awareness."
                },
                {
                    "type": "paragraph",
                    "text": "The choices then generated by such a framework are, by their nature, conducive towards preparation of one\'s perceptual structure for direct reception of relevant information and the (self-powered engines of intelligent light that act to purify and align subtle tendencies of mind otherwise not easily or directly targetable to direct examination) necessary for advancement in this process."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "consciousness-redefined-2.png",
                    "text": "The virtuous pillars of this framework are:"
                },
                {
                    "type": "paragraph",
                    "text": "Gratitude, Patience, Truthfulness, Forgiveness, Appreciation, Compassion, Understanding, Humility, Valor"
                }
            ]
        },
        {
            "id": "evolution_vs_transformation",
            "title": "Evolution vs. Transformation",
            "subtitle": "Saviorship Model vs. Mastership Model",
            "content": [
                {
                    "type": "paragraph",
                    "imageUrl": "consciousness-redefined-4.png",
                    "text": "For 10,000 years, humanity has been in fear. Fear of each other, fear of themselves, fear of their environment. This fear - and the effects of this fear - can be plainly seen in man's physical, emotional, mental, and above all, spiritual environments."
                },
                {
                    "type": "paragraph",
                    "text": "Humanity has largely forgotten how to feel, and allowed their base material instincts to engineer a system of control based on future reward and present fear.  The system is simple: promise a reward of eternal salvation in return for present-time compliance and submission.  The task is accomplished by placing God outside the individual, and requiring them to pass through an authorized intermediary to regain their salvation."
                },
                {
                    "type": "paragraph",
                    "text": "The individual is in this way rendered impotent of Creative life force, and thus subjugates themselves readily in return for a promise of a future salvation, a promise that has even been monetized - to the clergy\'s great benefit - in the past."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "consciousness-redefined-5.png",
                    "text": "Even when the path is not this overtly fraught with hazard, the evolution / saviorship context remains, implying that the individual was born into this world incapable to make the most personal decisions for themselves relative to their connection with God, and thus must (either through their own efforts or the efforts of someone acting as intermediary to God) return to the moment before birth (or after death) to receive God's salvation and gain God's Love."
                },
                {
                    "type": "paragraph",
                    "text": "In Truth, God\'s Love is ever-present and boundless, and cannot be modified by any human slight or insult."
                },
                {
                    "type": "paragraph",
                    "text": "The process embedded in reality that all eventual coherent integrals follow thus naturally projects a framework of perception that presumes the presence of Source at all times, and proclaims God\'s love for her creation, rather than placing Man as a recipient of punishment for misbehavior."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-0.png",
                    "text": "This model is fundamentally based on transformation and mastership and places the individual as a full creative participant in the process of their existence, unimpeded in their direct and living connection to the Divine. The individual is focused on their transformational process and free to explore reality in whatever way they wish."
                },
                {
                    "type": "paragraph",
                    "text": "In this way, the individual\'s life becomes a journey of unfolding and mastery, unique to them and the divine creative force - a force with which they directly commune with on a regular basis."
                },
                {
                    "type": "paragraph",
                    "text": "When this happens, The Universe then naturally gives way to the individual and transforms, as if by magic, from one seemingly characterized by Darwininan evolution and cold survival of the fittest as a final destiny, to one vibrant and alive with Consciousness, creative force, and fundamental goodness."
                }
            ]
        },
        {
            "id": "life_is_light",
            "title": "Life is Light-Transmitted",
            "subtitle": "The Integration of Consciousness and Biology",
            "content": [
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-1.png",
                    "text": "The current conception of the evolution and transmigration of living systems is an understanding fundamentally rooted in the conception of life as a purely biological mechanism, arising only in a universe governed purely by physical laws. This presumption arises from a fundamental misinterpretation of the structure of reality and its nature."
                },
                {
                    "type": "paragraph",
                    "text": "Therefore, it is understandable that humans would interpret what they see before them as either signs of an invisible creator, or a process purely governed by physical laws. In Truth, both are in fact correct from their perspectives, and both eventually lead to the same conclusion - that the very structure of all things ultimately arises within Consciousness."
                },
                {
                    "type": "paragraph",
                    "text": "Scientists are beginning to discover this fact now through their research with water and DNA. They are seeing that water has properties which emergently mimic the DNA structure. They are observing the water forming chiral bonds with a DNA molecule, forming its own double helix."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-2.png",
                    "text": "Furthermore, scientists are discovering that water itself transmits an electromagnetic signal which naturally transmits the information of whatever DNA was last contained within it. This signal can be received by water as well, and scientists in labs have been able to produce new DNA by transmitting this signal through the Internet to another lab."
                },
                {
                    "type": "paragraph",
                    "text": "The implications of these discoveries should be clear to anyone who considers them for a moment. The main electromagnetic transmitter of information near Earth is the Sun. The earth, and our Sun. Our Sun is directly connected to our Galactic Heart, which is connected to the Cosmic Heart."
                },
                {
                    "type": "paragraph",
                    "text": "The Universe is a network of Life, in the same way that the Internet is a network of information. The experiences of life are recorded in the planetary Heart, which constantly transmits its information to the Solar Heart, which in turn is connected to the Galactic Heart and then the Cosmic Heart."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-4.png",
                    "text": "This connection is non-local because its mechanism is embedded within the fabric of reality as plank-scale quanta within an incompressible structure, known today as a proton. In effect, the only reason any phenomena persists at all is because protons continue to accumulate information due to Consciousness observing phenomena."
                },
                {
                    "type": "paragraph",
                    "text": "Because water is an emergent phenomena of Consciousness, it is reasonable to assume that DNA is as well."
                },
                {
                    "type": "paragraph",
                    "text": "DNA is not merely a happenstance molecule of life - it is the only complex molecule of its kind, a uniquely suited structure for performing the task it does - which is the expression of life in an environment that possesses water, which is itself uniquely emergently capable of transmitting DNA information through the EM spectrum, which is in itself an emergent property of the structure of reality, which is only Consciousness, referencing itself from conception to form."
                },
                {
                    "type": "paragraph",
                    "imageUrl": "evolution-and-consciousness-5.png",
                    "text": "Thus, life is inextricably and emergently inter associated with the very physics of reality. Biology is physics, expressing life. Physics is the mechanics of Consciousness, relating to itself."
                }
            ]
        }
    ]
}
export default book;